import Admin, { Role, hasRole } from '@/models/Admin'
import Vault from '@/models/Vault'

export default class EasyPolicy {
	viewAny(admin: Admin) {
		return true
	}

	view(admin: Admin, vault: Vault) {
		return true
	}

	create(admin: Admin) {
		return hasRole(admin, [Role.ADMIN, Role.PRODUCT])
	}

	update(admin: Admin, vault: Vault) {
		return hasRole(admin, [Role.ADMIN, Role.PRODUCT])
	}

	restore(admin: Admin, vault: Vault) {
		return hasRole(admin, [Role.ADMIN, Role.PRODUCT])
	}

	delete(admin: Admin, vault: Vault) {
		return hasRole(admin, [Role.ADMIN, Role.PRODUCT])
	}

	forceDelete(admin: Admin, vault: Vault) {
		return hasRole(admin, Role.ADMIN)
	}

	trash(admin: Admin) {
		return hasRole(admin, Role.ADMIN)
	}
}
